import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface RouteGuardProps {
  allowed: boolean;
  redirectTo?: string;
  children: ReactNode;
}

/** Redirects away when `allowed` is false; used for narrow landing pages. */
export const RouteGuard = ({ allowed, redirectTo = "/login", children }: RouteGuardProps) => {
  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
